import type { AuditItemPagination } from '@internal-audit/components/AuditItemsFilters';

import { Pagination } from '../../../core/components';

interface PaginationInfo {
  totalPages: number;
  startIndex: number;
  endIndex: number;
  currentPageItems: number;
}

interface AuditItemsPaginationProps {
  paginationInfo: PaginationInfo | null;
  pagination: AuditItemPagination;
  isLoading?: boolean;
  onPageChange: (page: number) => void;
}

/**
 * Pagination controls for audit items
 * Only renders when there are multiple pages
 */
export function AuditItemsPagination({ paginationInfo, pagination, isLoading = false, onPageChange }: AuditItemsPaginationProps) {
  // Don't render if no pagination info or only one page
  if (!paginationInfo || paginationInfo.totalPages <= 1) {
    return null;
  }

  return <Pagination currentPage={pagination.currentPage} disabled={isLoading} totalPages={paginationInfo.totalPages} onPageChange={onPageChange} />;
}
